module.exports = __webpack_public_path__ + "img/wangyipeng.ac37d9cd.png";